import { render, staticRenderFns } from "./AHNoSearchResults.vue?vue&type=template&id=78a8ba4a&"
import script from "./AHNoSearchResults.vue?vue&type=script&lang=ts&"
export * from "./AHNoSearchResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports